import React from 'react'
import { Navigate } from 'react-router-dom';

const IsAuth = ({children}) => {
  const token = window.localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;

}

export default IsAuth